const messageRegister = {};

function registerFrameMessageHandler(messageType, handler) {
  if (typeof messageType !== "string") {
    throw new Error("Message type must be a string");
  }
  if(typeof handler !== "function") {
    throw new Error("Handler must be a function");
  }

  messageRegister[messageType] = handler;
}

function relayMessageToIframes(message) {
  const iframes = document.querySelectorAll('iframe');
  for(let i = 0; i < iframes.length; ++i) {
    const iframe  = iframes[i];
    iframe.contentWindow.postMessage(message, window.location.origin);
  }
}

function setUpIframeCommunication() {
  window.addEventListener("message", (event) => {
    // only allow same-origin messages with this handler
    if(event.origin!== window.location.origin) {
      return;
    }
    let message = event.data;
    if(typeof message !== "object") {
      console.info("seltmann CMS message handler did not receive object", message);
      return;
    }
    const messageType = message.type;
    if(typeof messageType === "undefined") {
      console.info("message received by seltmann CMS handler does not contain a valid message type, might be unrelated message", message);
      return;
    }
    if(typeof messageRegister[messageType]!== "function") {
      console.warn("message event handler received unknown message:", message);
    }
    messageRegister[messageType](message);
    relayMessageToIframes(message);
  });
}

export {setUpIframeCommunication, registerFrameMessageHandler};
